export enum ResumeUploadsStatus {
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed"
}

export enum Portals {
  HCMS = "HCMS",
  COREHCS = "COREHCS",
  COREHCMS = "COREHCMS",
  INCEPTION = "INCEPTION",
  DIGITAL_HUMAN = "DIGITAL_HUMAN",
  KU = "KU",
  MA = "MA"
}

export enum EmailTypes {
  RESEND_EMAIL = "resend-email",
  ONBOARDING_INVITE = "onboarding-invite",
  TWO_POINT_INTERNAL_JOB_POST = "two-point-internal-job-post",
  BULK_INVITE = "bulk-invite",
  BULK_REJECT = "bulk-reject"
}

export enum JobDataTypes {
  SCREENING_QUESTIONS = "screening_questions",
  TEXT = "text"
}

export enum SocketEvents {
  DIGITAL_HUMAN_CONSUMPTION = "digital-human-consumption"
}
